<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/w6iLDP/tc-custom/9780545683074.jpg?1702236522033" alt="This image is the cover for the book Quest of the Cubs, Bears of the Ice"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Quest of the Cubs, Bears of the Ice
      </h1>
      <p class="bookDescription body article font2">
        <b>From the author of <i>Guardians of Ga’Hoole</i>, “nature, magic, and legend combine to create a world like no other” in a tale of polar cubs on a rescue mission (<i>Kirkus Reviews</i>).</b><br/><br/>For generations, the noble polar bears have ruled the Northern Kingdoms. But now, their society is on the brink of collapse. A group of power-hungry bears has seized control, and darkness is creeping across the snow. Cubs First and Second don’t know any of this. Although they’re twins, they couldn’t be more different. First loves imagining stories, while his daring sister, Second, wants to live them. When their mother is taken prisoner, the cubs’ world falls apart. They know they have to rescue her, but how can two cubs who’ve barely learned to hunt survive a treacherous journey across the ice? Their only chance is to learn to trust each other and—even more important—trust themselves. But survival is only the beginning. And soon, these two unlikely heroes find themselves at the heart of a battle unlike anything Ga’hoole has ever seen.<br/><br/>“Readers will lose themselves in the life-and-death adventure of the cubs and succumb to human feelings of fear, loss, and hope . . .” —<i>Booklist</i><br/><br/>“A series opener that promises to deliver action and adventure.” —<i>School Library Journal</i><br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kathryn Lasky
      </h2>
      
      <p class="authorDescription body article"> Kathryn Lasky is the Newbery Honor-winning author of over 100 books for children and young adults. Her beloved Guardians of Ga'Hoole fantasy series has more than seven million copies in print, and she is the author of the Daughters of the Sea series and the Wolves of the Beyond series, as well as <I>A Time for Courage</I> and other Dear America titles. Kathryn has also written a number of critically acclaimed historical fiction titles, such as <I>Beyond the Burning Time</I> and <I>True North</I>. She lives with her husband in Cambridge, Massachusetts. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Scholastic Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4b0a0db6